import React from 'react'
import Topslider from './topslider'
import Itdarea from './itdarea'
import Topsearchs from './topsearchs'
import Tophashtags from './tophashtags'
import Topsellers from './topsellers'
import Brandsyoumayknow from './brandsyoumayknow'
const Index = () => {
  return (
    <div className='form_container'>
      <div className='admin_form_container'>
        <Topslider/>
        <Itdarea/>
        <Topsearchs/>
        <Tophashtags/>
        <Topsellers />
        <Brandsyoumayknow />
      </div>
    </div>
  )
}

export default Index
